// Central constants for DataTableAction module

// Layout & Dimensions
export const FILTER_MENU_WIDTH = '45vh';
export const TABLE_BODY_HEIGHT = '700px';
export const FILTER_VALUE_MAX_HEIGHT = '25vh';
export const DEFAULT_ITEMS_PER_PAGE = 10;
export const DEBOUNCE_FILTER_MS = 250;
/** Default max column width (px) when header has no maxWidth */
export const DEFAULT_COLUMN_MAX_WIDTH = 280;
/** Teleported column-filter v-menu — above sticky table headers (--z-overlay). */
export const COLUMN_FILTER_MENU_Z_INDEX = 900;

// Filter Sentinel Values
export const NONE_SENTINEL = 'NONE_SELECTED';

// API Endpoints
export const API_REMOVE_CUSTOM_LAYOUT = '/v2/financialclose/analysis/removecustomlayout';

// Logging Prefix
export const LOG_PREFIX = '[DataTableAction]';

/**
 * Header prop `linkHover: true` — apply this class on the cell/content so
 * hover shows an underline (clickable / navigate affordance).
 * DataTableAction also merges it into header.cellClass via computedHeaders.
 */
export const LINK_HOVER_CELL_CLASS = 'data-table-action__cell--link-hover';

/** Attribute storing the full cell text for the truncation tooltip. */
export const TRUNCATE_TEXT_ATTR = 'data-truncate-text';
